// Fetch a render job by id (cached). Used as a fallback to display makeovers
// whose finished renders never synced from the phone — the backend job stays
// completed with all renders + presigned URLs, so the web can show them anyway.

import { useQuery } from "@tanstack/react-query";
import { getJob } from "./apiClient";
import type { Job } from "./types";

export function useJob(jobId: string | null | undefined, enabled = true) {
  return useQuery<Job>({
    queryKey: ["job", jobId],
    queryFn: () => getJob(jobId as string),
    enabled: !!jobId && enabled,
    staleTime: 5 * 60 * 1000,
    retry: 1,
  });
}
